import { createTheme } from '@mantine/core';

const THEME_OTHER = {
  colors: {
    primary: {
      100: '#1B6DE7',
      200: '#0B5BD0',
      300: '#7FB0F9',
      400: '#1B6DE74D',
      500: '#1B6DE70D',
    },
    darkPrimary: {
      100: '#29282E',
      200: '#3D3C41',
      300: '#54545B',
      400: '#353436',
    },
    grayscale: {
      100: '#FFFFFF',
      200: '#FCFCFC',
      300: '#F7F7F7',
      400: '#F8F8F8',
      500: '#D9D9D9',
      600: '#B4B4B4',
      700: '#8E8E8E',
      800: '#3C444A',
      900: '#D9D9D933',
      1000: '#676666',
    },
    darkGrayscale: {
      100: '#AFAFAF',
      200: '#C6C6C6',
    },
    additional: {
      100: '#D9534F',
      200: '#44B263',
      300: '#44B26333',
      400: '#8C81F299',
      500: '#BAB3F7',
      600: '#A6CAE3',
      700: '#A6CAE399',
    },
    darkAdditional: {
      100: '#44B26340',
      200: '#D9D9D940',
      300: '#8C81F2',
    },
    bg: {
      100: '#FFFFFF',
      200: '#F4F4F4',
    },
  },
} as const;

const internalTheme = createTheme({
  other: THEME_OTHER,
});

export const theme = {
  ...internalTheme,
  other: THEME_OTHER,
};
